import { getI18n } from 'src/i18n/i18n.middleware'
import { dynamic } from 'src/utils/ssr'
import { profileMeta, profileMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.news._index'

const getClientModule = () => import('src/clientRoutes/_app.news._index')

export const handle = {
  name: 'news-list',
  track: { scene: 'news', section: 'list' },
}

/** SSR loader. Source: https://github.com/troph-team/pixai/blob/main/packages/pixai-server/src/ssr/router.ts#L285-L311 */
export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return profileMetaLoader({
    requestUrl: request.url,
    title: t('common:news.title', { context: 'long' }),
  })
}

/** Meta function for SSR SEO. */
export function meta({ loaderData }: Route.MetaArgs) {
  return profileMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
